export default __webpack_public_path__ + "static/media/Tractor.cb4ff514.svg";